import React, { useEffect } from 'react';
import { useState } from 'react';
import { Divider, Input } from '@roo/roo';
import { useSimpleContext } from '../../apply/_context';
//import { StageItem } from '../../apply/innovate/apply/detail';
import { renderDetailByColumns, renderDetailListByColumns, renderFile, renderTextArea, renderDirection } from '../scientist/util';
import '../index.scss';

const { Textarea } = Input;

const messengerColumns = [{
    label: '姓名',
    key: 'name'
}, {
    label: '职位',
    key: 'job'
}, {
    label: '手机号码',
    key: 'phone'
}, {
    label: '联系邮箱',
    key: 'email'
}];

const basicColumns = [{
    label: '项目名称',
    key: 'projectName'
}, {
    label: '项目所在地',
    key: 'projectLocation'
}, 
// {
//     label: '项目总投资',
//     key: 'investmentAmount'
// }, 
{
    label: '占地面积',
    key: 'locationArea'
}, {
    label: '开工日期',
    key: 'startDate'
}, {
    label: '竣工日期',
    key: 'endDate'
}, {
    label: '项目申报方向',
    key: 'reportDirection',
    _render: renderDirection
}];

const detailColumns = [{
    label: '立项依据及工作基础',
    key: 'projectBackground',
    _render: renderTextArea
}, {
    label: '项目简介',
    key: 'introduction',
    _render: renderTextArea
}, {
    label: '自主创新',
    key: 'innovation',
    _render: renderTextArea
}, {
    label: '项目可行性',
    key: 'feasibility',
    _render: renderTextArea
}, {
    label: '预期成果效益',
    key: 'achievement',
    _render: renderTextArea
}, {
    label: '示范性年度实施进度计划',
    key: 'stages',
    _render: (item) => {
        const { stages } = item;
        return (
            <div className={'cert-table innovate-preview-cert-table'}>
                <div className={'c-title'}>时间节点</div>
                <div className={'c-title'}>任务</div>
                <div className={'c-title'}>成果形式</div>
                {
                    (stages || []).map((item) => {
                        return (
                            <>
                                <div className={'c-time'}>
                                    <Textarea
                                        className={'c-area'}
                                        resize='none'
                                        disabled
                                        value = {item.time}
                                    ></Textarea>
                                </div>
                                <div className={'c-task'} style={{position:"relative"}}>
                                    <Textarea
                                        className={'c-area'}
                                        resize='none'
                                        disabled
                                        value = {item.task}
                                    ></Textarea>
                                </div>
                                <div className={'c-achievement'} style={{position:"relative"}}>
                                    <Textarea
                                        className={'c-area'}
                                        resize='none'
                                        disabled
                                        value = {item.achievement}
                                    ></Textarea>
                                </div>
                            </>
                        )
                    })
                }
            </div>
        )
    }
}];

const managerColumns = [{
    label: '姓名',
    key: 'name'
}, {
    label: '年龄',
    key: 'age'
}, {
    label: '职务职称',
    key: 'position'
}];

const budgetColumns = [{
    label: '项目总预算',
    key: 'budgetOverall'
}, {
    label: '申请示范项目经费',
    key: 'budgetApply'
}, {
    label: '其他费用',
    key: 'otherBudgetExplanation',
    _render: renderTextArea
}, {
    label: '',
    required: false,
    key: 'budgetList',
    _render: (item) => {
        const { budgetList } = item;
        return (
            <div className={'cert-table innovate-preview-cert-table'}>
                <div className={'c-title'}>预计支出内容</div>
                <div className={'c-title'}>支出项目类别</div>
                <div className={'c-title'}>预计支出金额</div>
                {
                    (budgetList || []).map((_item) => {
                        const { item, type, amount } = _item;
                        return (
                            <>
                                <div className={'c-time'}>
                                    <Textarea
                                        className={'c-area'}
                                        resize='none'
                                        disabled
                                        value = {item}
                                    ></Textarea>
                                </div>
                                <div className={'c-task'} style={{position:"relative"}}>
                                    <Textarea
                                        className={'c-area'}
                                        resize='none'
                                        disabled
                                        value = {type}
                                    ></Textarea>
                                </div>
                                <div className={'c-achievement'} style={{position:"relative"}}>
                                    <Textarea
                                        className={'c-area'}
                                        resize='none'
                                        disabled
                                        value = {amount}
                                    ></Textarea>
                                </div>
                            </>
                        )
                    })
                }
            </div>
        )
    }
}, {
    label: '预算说明',
    key: 'budgetExplanation',
    _render: renderTextArea
}]

const sealColumns = [{
    label: '上传单位公章',
    key: 'officialSealUrl',
    layout: 'vertical',
    _render: renderFile
}]

const cols = { field: { span: 9, offset: 0, }, label: { span: 3 } }

export default ({detail: applyInfo}) => {
    const { personResponsible, budgetList } = applyInfo;
    return (
        <>
            <h3 id="messenger" className='catalogue-tag'>申报主要联系人信息</h3>
            <Divider />
            {
                renderDetailByColumns(applyInfo, messengerColumns, cols)
            }
            <h3 id="projectBasic" className='catalogue-tag'>项目基本信息</h3>
            <Divider />
            {
                renderDetailByColumns(applyInfo, basicColumns, cols)
            }
            {/* <h3 id="projectDetail" className='catalogue-tag'>项目详情</h3>
            <Divider />
            {
                renderDetailByColumns(applyInfo, detailColumns, cols)
            }
            <h3 id="projectManager" className='catalogue-tag'>项目负责人及主要参加人员</h3>
            <Divider />
            {
                renderDetailListByColumns(personResponsible, managerColumns, cols)
            } */}
            <h3 id="budget" className='catalogue-tag'>项目预算</h3>
            <Divider />
            {
                renderDetailByColumns(applyInfo, budgetColumns, cols)
            }
            <h3 id="seal" className='catalogue-tag'>上传单位公章</h3>
            <Divider />
            {
                renderDetailByColumns(applyInfo, sealColumns, cols)
            }
        </>
    )
}